import React from 'react';
import InputField from '../../components/UI/Forms/InputField';
import { FieldValues, useForm } from 'react-hook-form';
import ErrorMessage from '../../components/UI/Notifications/ErrorMessage';
import Button from '../../components/UI/Buttons/Button';
import { Link } from 'react-router-dom';
import { validationSchema } from '../../utility/validation';
import { showToastNotification } from '../../utility/helper';
import { callApi } from '../../api/callApi';
import { API_ENDPOINT, API_URL } from '../../api/constant';

const ForgotPassword: React.FC = () => {
    const { register, handleSubmit, formState: { errors } } = useForm({ mode: 'onBlur' });

    const onSubmit = (data: FieldValues) => {
        let postData = {
            "email": data.email,
            "phone": '',
            "deviceId": "",
            "deviceToken": ""
        }
        const response: any = callApi(API_URL + API_ENDPOINT.auth + 'user/forgot-password', { data: postData, method: 'POST' });
        if (response.status === true) {

        } else {
            showToastNotification('danger', response.message)
        }
    };

    return (
        <div className='app-login app-login p-0 position-relative'>
            <div className="app-auth-body mx-auto position-relative z-1">
                <div className="app-auth-branding mb-4"><a className="app-logo" href="javascript:void(0)"><img className="logo-icon" src="/assets/images/app-logo.svg" alt="logo" /></a></div>
                <h2 className="auth-heading text-center mb-5 text-white">Forgot password</h2>
                <div className="auth-form-container text-start">

                    <form className="auth-form forgot-password-form" onSubmit={handleSubmit(onSubmit)} >
                        <div className="email mb-3">
                            <label className="sr-only" htmlFor="forgot-email">Email</label>
                            <InputField register={register('email', {
                                required: validationSchema.email.required,
                                pattern: {
                                    value: validationSchema.email.pattern.regex,
                                    message: validationSchema.email.pattern.message
                                }
                            })} name="email" type="email" className="forgot-email" placeholder="Email address" />
                            <ErrorMessage message={errors.email?.message?.toString()} className='text-danger' />
                            <div className="extra mt-3 row justify-content-between">
                                <div className="col-6">
                                </div>
                                <div className="col-6">
                                    <div className="forgot-password text-end">
                                        <Link className='fw-semibold' to={"/"} >Login</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="text-center">
                            <Button type="submit" loading={false} className="app-btn-primary w-100 theme-btn mx-auto" text='Send Reset Link' />
                        </div>
                    </form>
                </div>
            </div>

            <div className="auth-background-holder">
            </div>
        </div>
    );
};

export default ForgotPassword;
